export default __webpack_public_path__ + "static/media/2706.c13dc5d1.png";